import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GetMyPrincipal, GetRights } from 'nallian-shared-ui/lib/selectors';
import { hasDocumentAccess } from '../helpers/documents/hasDocumentAccess';

export const useCanAccessDocuments = (orgId, targetPrincipalId) => {
  const rights = useSelector(GetRights);
  const myPrincipal = useSelector(GetMyPrincipal);
  const principalOrgId = myPrincipal?.organisation?.id;
  const myPrincipalId = myPrincipal?.id;

  return useMemo(
    () => ({
      read:
        myPrincipalId === targetPrincipalId ||
        hasDocumentAccess(rights, orgId, principalOrgId, 'read'),
      manage: hasDocumentAccess(rights, orgId, principalOrgId, 'manage'),
    }),
    [rights, orgId, principalOrgId, myPrincipalId, targetPrincipalId]
  );
};

export default useCanAccessDocuments;
